import React from 'react';
import { Star, Quote, ArrowDown } from 'lucide-react';
import { Card } from './ui/Card';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María González',
    location: 'Miami, FL',
    role: 'Ex-Mesera',
    image: 'https://images.unsplash.com/photo-1589156280159-27698a70f29e?auto=format&fit=crop&q=80&w=200&h=200',
    quote: 'Nunca pensé que podría ganar más desde mi sofá que trabajando 12 horas de pie en el restaurante. Este método cambió mi vida y la de mis hijos. ¡Gracias!',
    result: 'Generó $1,200 en su primera semana'
  }, {
    name: 'Sofia Ramirez',
    location: 'Houston, TX',
    role: 'Mamá a tiempo completo',
    image: 'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?auto=format&fit=crop&q=80&w=200&h=200',
    quote: 'Estaba escéptica, pero por $17 decidí probar. El Script de Oro es real. Cerré mi primer cliente al tercer día y no podía creerlo cuando vi el depósito.',
    result: 'Renunció a su trabajo de limpieza'
  }, {
    name: 'Carolina Méndez',
    location: 'Los Angeles, CA',
    role: 'Estudiante',
    image: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?auto=format&fit=crop&q=80&w=200&h=200',
    quote: 'Lo mejor es que no necesitas experiencia. La guía te dice exactamente qué decir. Ahora pago mis estudios sin tener que pedir préstamos.',
    result: 'Gana $500 extra cada fin de semana'
  }];
  const scrollToPrecios = () => {
    document.getElementById('precios')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-12 pb-6 bg-brand-light relative overflow-hidden" data-id="element-251">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-rose-200 rounded-full blur-[100px] opacity-30 -translate-y-1/2 translate-x-1/3" data-id="element-252"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-253">
        <div className="text-center mb-8" data-id="element-254">
          <span className="text-brand-primary font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-255">
            Historias Reales
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-medium text-brand-dark mb-4" data-id="element-256">
            Ellas ya escaparon del 9-a-5. <br data-id="element-257" />
            <span className="text-brand-secondary italic" data-id="element-258">
              ¿Serás tú la siguiente?
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-259">
          {testimonials.map((t, i) => <Card key={i} className="p-6 hover:shadow-xl transition-shadow duration-300 border-t-4 border-t-brand-primary" data-id="element-260">
              <div className="flex items-center gap-1 mb-4" data-id="element-261">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-brand-gold fill-brand-gold" data-id="element-262" />)}
              </div>

              <div className="relative mb-4" data-id="element-263">
                <Quote className="absolute -top-2 -left-2 w-7 h-7 text-brand-soft transform -scale-x-100" data-id="element-264" />
                <p className="text-brand-dark/80 italic relative z-10 pl-4 text-sm" data-id="element-265">
                  "{t.quote}"
                </p>
              </div>

              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-rose-100" data-id="element-266">
                <img src={t.image} alt={t.name} className="w-10 h-10 rounded-full object-cover border-2 border-brand-primary" data-id="element-267" />
                <div data-id="element-268">
                  <h4 className="font-bold text-brand-dark text-sm" data-id="element-269">
                    {t.name}
                  </h4>
                  <p className="text-xs text-brand-muted" data-id="element-270">
                    {t.location} • {t.role}
                  </p>
                </div>
              </div>

              <div className="mt-3 bg-green-50 text-green-700 text-xs font-bold px-3 py-2 rounded-lg text-center" data-id="element-271">
                ✨ {t.result}
              </div>
            </Card>)}
        </div>

        {/* Scroll-to-price CTA */}
        <div className="mt-8 text-center" data-id="element-272">
          <p className="text-brand-muted text-sm uppercase tracking-widest font-semibold mb-3" data-id="element-273">
            ¿Lista para ser la siguiente historia de éxito?
          </p>
          <button onClick={scrollToPrecios} className="inline-flex flex-col items-center gap-2 group" data-id="element-274">
            <span className="inline-flex items-center gap-2 bg-brand-primary text-white font-bold uppercase tracking-wider text-sm px-8 py-4 rounded-full shadow-lg shadow-rose-300/40 hover:bg-rose-700 transition-all duration-200 hover:shadow-rose-400/50 hover:shadow-xl" data-id="element-275">
              VER MI PRECIO ESPECIAL
            </span>
            <ArrowDown className="w-5 h-5 text-brand-primary animate-bounce group-hover:text-rose-700 transition-colors" data-id="element-276" />
          </button>
        </div>
      </div>
    </section>;
}